<p id="modalContent">
    @if (modalOptions) {
        <ap-content key="{{ modalOptions.options.contentKey }}" [params]="modalOptions.options.params ? modalOptions.options.params : {}">
        </ap-content>
    }
</p>
<ap-button
    id="cancelButton"
    type="button"
    (click)="cancel()"
    ariaLabel="{{ 'global.additional-info.modal.close-button.label' | apContent }}"
    >Sluiten</ap-button
>
